
const digest = 'f05afb76d4ae0910ff5057454fca9d7422aa4d70c2660a21d3aaba9621cf1b57';
const css = `._dividerLine_yf9v2_1 {
  border-top: 1px solid var(--theme-secondary-border);
  margin-top: 20px;
  margin-bottom: 20px;
}

._selected_yf9v2_7 {
  border-top: 2px solid var(--aha-blue-500);
  margin-bottom: 19px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"dividerLine":"_dividerLine_yf9v2_1","selected":"_selected_yf9v2_7"};
export { css, digest };
  